import { Outlet, createRootRoute } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ImagePrefetch } from '@/components/ImagePrefetch';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <div className="h-screen bg-fill-surface-strong flex flex-col">
      <Outlet />
      <ImagePrefetch />
      <ReactQueryDevtools />
      <TanStackRouterDevtools position="bottom-left" />
    </div>
  );
}
